import './bullseye.css';
export default {
  "bullseye": "pf-v6-l-bullseye"
};